import { ref } from 'vue';

const useDebouncedCallback = (callback, delay) => {
    const timeout = ref();
    const debouncedFn = (...args) => {
        const handler = () => {
            clearTimeout(timeout.value);
            callback(...args);
        };
        clearTimeout(timeout.value);
        timeout.value = setTimeout(handler, delay);
    };
    return debouncedFn();
};

export { useDebouncedCallback };
//# sourceMappingURL=useDebouncedCallback.js.map
